{
  "title": "Notifications",
  "description": "Alerts about your servers, invoices and team.",
  "kinds": {
    "payment_failed": {
      "title": "A payment of {{amount}} failed",
      "body": "The subscription payment for {{server}} didn't go through. Pay within the grace period so the control panel doesn't lock."
    },
    "invoice_paid": {
      "title": "Invoice {{number}} paid",
      "body": "We received {{amount}}. Thank you."
    },
    "server_activated": {
      "title": "{{server}} is activated",
      "body": "The server is connected and running."
    },
    "server_grace": {
      "title": "{{server}} can't reach bPanel",
      "body": "Websites run as usual, but adding new accounts stops if the server doesn't connect before the grace period ends."
    },
    "update_available": {
      "title": "Version {{version}} is available",
      "body": "Update {{server}} to get the latest improvements and fixes."
    },
    "trial_ending": {
      "title": "Your free trial ends soon",
      "body": "Set up payment before the trial ends so the control panel on your servers doesn't lock."
    },
    "credits_low": {
      "title": "AI credits are running low on {{server}}",
      "body": "Buy extra credits or turn on auto top-up."
    },
    "member_joined": {
      "title": "{{name}} joined the team",
      "body": "They now have access based on their role."
    },
    "ticket_reply": {
      "title": "New reply on ticket {{number}}",
      "body": "Support replied to your ticket."
    },
    "server_key_reissued": {
      "title": "New activation key for {{server}}",
      "body": "{{name}} issued a new key. The server switches to it at its next check-in, then the old key stops working."
    },
    "server_transfer_started": {
      "title": "Transfer of {{server}} started",
      "body": "Install bPanel on the new server with the new activation key."
    },
    "server_old_installation_deactivated": {
      "title": "Old installation on {{server}} stopped",
      "body": "The old server checked in and its subscription stopped there. Sites on it keep running."
    },
    "credits_exhausted": {
      "title": "AI credits ran out on {{server}}",
      "body": "AI requests on this server are paused until you buy credits or the monthly allowance renews."
    },
    "credits_topped_up": {
      "title": "{{credits}} credits added to {{server}}",
      "body": "Auto top-up bought them because the balance was running low."
    },
    "release_published": {
      "title": "bPanel {{version}} is out",
      "body": "A new release on the $t(notifications:channels.{{channel}}) channel. See what is new and which servers can update."
    },
    "ticket_resolved": {
      "title": "Ticket {{number}} resolved",
      "body": "Support closed the ticket. Rate the experience or reopen it if the issue is still there."
    },
    "server_past_due": {
      "title": "{{server}} is waiting for payment",
      "body": "The renewal payment didn't go through. The server runs normally, and the control panel locks if it isn't paid within the grace period."
    },
    "server_locked": {
      "title": "The control panel on {{server}} is locked",
      "body": "The subscription has ended. Websites, mail, databases and DNS keep running, and nothing is deleted. Renew to unlock the panel."
    },
    "server_unlocked": {
      "title": "The control panel on {{server}} is unlocked",
      "body": "The server checked in with bPanel after the renewal, and everything is running."
    }
  },
  "filters": {
    "all": "All",
    "unread": "Unread",
    "label": "Show notifications",
    "category": "Kind",
    "markCategory": "Mark {{category}} as read"
  },
  "empty": {
    "unreadTitle": "You're all caught up",
    "body": "Important alerts about your servers, invoices and team show up here.",
    "categoryTitle": "No notifications of this kind"
  },
  "channels": {
    "stable": "stable",
    "beta": "beta"
  },
  "categories": {
    "all": "All kinds",
    "billing": "Billing",
    "servers": "Servers",
    "updates": "Updates",
    "team": "Team",
    "support": "Support",
    "other": "Other"
  },
  "preferences": "Notification settings",
  "fallback": {
    "title": "New notification",
    "body": "Open it to see the details."
  }
}
